import { Invoice } from '../../domain/models/invoice';
import { Client } from '../../domain/models/client';

export class InvoiceVM extends Invoice {
  orderSourceId: number = null;
  self: Invoice = null;
  client: Client = null;
  invoiceTypeName: string = null;
}
